import { ModalContent } from "./modalContent";
import Modal from "./Modal";
import ModalLink from "./ModalLink";
import { ModalLinkProps, ModalProps } from "./modalProps";

export {
    ModalContent,
    Modal,
    ModalProps,
    ModalLink,
    ModalLinkProps,
};
